import { IGetAllEntregaObrasClienteArquivoUseCase } from "../../../presentation/useCases/read/get_all_entrega_obras_cliente_arquivo_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";
import { EntregaObraClienteArquivoModel } from "../../models/entrega_obra_cliente_arquivo";


/**
 * GetAllEntregaObrasClienteArquivoUseCase
 */

export class GetAllEntregaObrasClienteArquivoUseCase
  extends BasePaginatedUseCase<EntregaObraClienteArquivoModel>
  implements IGetAllEntregaObrasClienteArquivoUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) {
    super();
  }

  async execute(idEntregaObra: number): Promise<void> {
    const result = await this.repository.getAllEntregaObrasClienteArquivos(idEntregaObra);

    this._items = result.items;
    this._currentPage = result.currentPage;
    this._pageSize = result.pageSize;
    this._totalItems = result.totalItems;
    this._totalPages = result.totalPages;

  }
}
